//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import IconLink from 'components/Shared/IconLink/Index'

const AddChildTicketsLink = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <IconLink
      onClick={onClick}
      iconName='icon-import'
      text={t('ticketPage.addChildTicketsLink')}
    />
  )
}

AddChildTicketsLink.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default AddChildTicketsLink
